import React from 'react';
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage"; 
import { useRouter } from 'next/router';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';
interface Props {
  data: any;
  jotformId: any;
  externalLink :any;
}

const EduFairFooterCommon: React.FC<Props> = ({ data, jotformId, externalLink }) => {
  const { zipmeLink, generateLink } = useZipmeLink();
  const router = useRouter();
  return (
    <div
      id='edu-fair-footer'
      className={styles.footer}
      style={{ backgroundColor: data?.sectionTopBgColor || '#fff' }}
    >
      <Container>
        <div className={styles.content}>
          <Row>
            <div id='edu-fairlog' className={styles.footerLogo}>
                <CustomImage
                  src='/images/educationfair/kc_logo.svg'
                  width={200}
                  height={58}
                  className={styles.studImg}
                  alt='kclogo'
                />
            </div>
          </Row>
          <Row>
            {data?.offices?.length > 0 &&
              data?.offices.map((office: any, index: number) => {
                return (
                  <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className={styles.address}>
                      <h4>{office?.officeName}</h4>
                      {office?.address &&
                        <p>
                          <span>{ office.addressLabel || 'Address'} : </span>
                          {office.address}
                        </p>
                      }
                      {office?.contact &&
                        <p>
                          <span>{ office.contactLabel || 'Contact Us' } : </span>
                          {office.contact}
                        </p>
                      }
                    </div>
                  </Col>
                );
              })}
          </Row>
          <div className={`d-none d-sm-block ${styles.tagline}`}>
            <Row>
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                <h6>{data?.fulfillText}</h6>
              </Col>
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                <div className={styles.bgkc}>
                  <a  className={`${styles.foterReg} ${jotformId ? `${isFrappeOrJotFormClass(jotformId)}` : '' }`} 
                      onClick = {()=>{
                        !jotformId && generateLink(externalLink);
                      }}>
                    { data.button?.label || 'Register Now' }
                  </a>
                  <script
                    dangerouslySetInnerHTML={{
                      __html: `window.lintrk('track', { conversion_id: 6870956 });`,
                    }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default EduFairFooterCommon;
